// @givmo/api-client — same-origin gating.
//
// Ports the `_isSameOriginAsBase` guard shared by the Dio `TokenInterceptor` and
// `AppCheckInterceptor`: the `Authorization` / `X-Firebase-AppCheck` headers are
// attached ONLY when the request target is same-origin (scheme + host + port) as
// the configured API base. A cross-origin request (a third-party CDN, an OAuth
// redirect) must never receive a Firebase ID token or App Check token.

/** True when `targetUrl` shares scheme + host + port with `baseUrl`. */
export function isSameOriginAsBase(targetUrl: string, baseUrl: string): boolean {
  if (!baseUrl) return false;
  let base: URL;
  let target: URL;
  try {
    base = new URL(baseUrl);
    target = new URL(targetUrl, baseUrl);
  } catch {
    return false;
  }
  return (
    base.protocol === target.protocol &&
    base.hostname === target.hostname &&
    base.port === target.port
  );
}
